import { Box } from "@mui/material";
import RepresentationsHero from "./subPages/RepresentationsHero";
import CategoriesSection from "./subPages/CategoriesSection";
import NavBar from "../NavBar/NavBar";
import { useState } from "react";
import SEO from "../app/SEO";

export default function RepresentationsPage() {
  const [lightNav, setLightNav] = useState(true);
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#F6F5F3",
      }}
    >
      <SEO
        title="Services| Talent Representation, Bookings & Fan Experiences"
        description=""
        canonical={``}
        ogImage={""}
      />
      <NavBar mode={lightNav ? "light" : "dark"} />
      {/* HERO / INTRO SECTION */}
      <RepresentationsHero onVisibilityChange={setLightNav} />

      {/* NEXT: Categories Grid (we build next) */}
      <CategoriesSection />
    </Box>
  );
}
